export enum TaskVisibilityEnum {
  full = 1,
  hidden = 2
}
